export default "__VITE_ASSET__CARSzzDv__"